import React, { useState, useEffect } from "react"

import GlobalContext from "./GlobalContext"

const ContextWrapper = (props) => {

    const localSettingsKey = 'app-vb-settings'
    const defaultData = {
        'whatLearning': 'English',
        'whatKnow': 'Spanish',
        'yourLevel': 'B1 Intermediate',
        'isDarkMode': true
    }

    const localData = JSON.parse(localStorage.getItem(localSettingsKey))
    const localSettings = !localData ? defaultData:localData

    const firstStep = !localData ? true:false

    const [globalSettings, setGlobalSettings] = useState(localSettings)

    useEffect(() => {
        localStorage.setItem(localSettingsKey, JSON.stringify(globalSettings))
    }, [globalSettings])

    
    return (
        <GlobalContext.Provider value={({
            firstStep,

            globalSettings,
            setGlobalSettings
        })}>
            { props.children }
        </GlobalContext.Provider>
    )
}

export default ContextWrapper